/**
 * 3d模型
 * @param {*} id
 * @param {*} url 模型url地址
 * @param {*} origin 模型位置 {x:0,y:0,z:0}
 * @param {*} option  配置项
 * @param {*} option.type 模型的类别
 * @param {*} option.x  旋转模型x
 * @param {*} option.y 旋转模型y
 * @param {*} option.z 旋转模型z
 */
export default function addModel(
  id,
  url,
  origin,
  { type = 'fbx', x = 0, y = 0, z = 0, scale = 1 }
) {
  let { mapbox } = this
  mapbox.addLayer({
    id,
    type: 'custom',
    renderingMode: '3d',
    onAdd: function(map, mbxContext) {
      window.tb = new Threebox(map, mbxContext, { defaultLights: true })
      if (type === 'fbx') {
        new THREE.FBXLoader().load(url, obj => {
          obj.scale.set(scale, scale, scale)
          obj.rotateX(x)
          obj.rotateY(y)
          obj.rotateZ(z)
          let ob = tb.Object3D({ obj }).setCoords(origin)
          tb.add(ob)
        })
      }
    },
    render: function(gl, matrix) {
      tb.update()
    }
  })
}



// WEBPACK FOOTER //
// ./src/framework/map/layer/Model.js